import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const ActorCardCmp_Person_Fragment = graphql(`
  fragment ActorCardCmp_Person_Fragment on Person {
    _id
    isInternal
    isVip
    color
    pictureImageUri
    civilityId
    fullName
    contactInfo {
      ...ContactInfoCmp_ContactInfo_Fragment
    }
    categoryIds
  }
`);

export type ActorCardCmp_Person = ResultOf<typeof ActorCardCmp_Person_Fragment>;
